import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=165ce234&scoped=true&"
import script from "./Configurator.vue?vue&type=script&lang=ts&"
export * from "./Configurator.vue?vue&type=script&lang=ts&"
import style0 from "./Configurator.vue?vue&type=style&index=0&id=165ce234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165ce234",
  null
  
)

export default component.exports